import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  private _opened = false;

  get opened(): boolean {
    return this._opened;
  }

  toggle() {
    this._opened = !this._opened;
  }

}
